import { X } from 'lucide-react'
import { FormWrapper } from '@/form-control'
import { DateField, TextField, TimeField } from '@/form-control/fields'
import ROUTES from '@/ROUTES'

import { IEvent } from '@/MODELS/event.model'

interface IEventForm {
    id?: string
    selectedDate?: Date
    onCancel: () => void
    onSuccess: () => void
}

export default function AddEventForm(props: IEventForm) {
    const { id, onCancel, onSuccess, selectedDate } = props

    const getDefaultDateTime = () => {
        const now = new Date()
        now.setSeconds(0, 0)
        return now
    }

    return (
        <div className='bg-white shadow-sm rounded-xl animate-fade-down'>
            <div className='p-6'>
                <div className='flex items-center justify-between mb-4'>
                    <h3 className='text-lg font-semibold text-gray-900'>Add New Event</h3>
                    <button onClick={onCancel} className='p-1 text-gray-400 transition-colors hover:text-gray-600'>
                        <X className='w-5 h-5' />
                    </button>
                </div>

                <FormWrapper<IEvent>
                    endpoint={ROUTES.app.event}
                    id={id ? id : 'new'}
                    defaultValues={{
                        title: '',
                        date: selectedDate ? selectedDate : getDefaultDateTime(),
                    }}
                    callbackAfterSubmit={() => {
                        onSuccess()
                    }}
                    submitButtonText='Add Event'
                    submitButtonAlignment='right'
                    className='space-y-4'
                    submitButtonClass={'bg-brand-500'}
                >
                    {(f) => (
                        <div className='space-y-4'>
                            <TextField
                                {...f('title')}
                                type='text'
                                label='Event Title'
                                placeholder='e.g., Doctor appointment, Therapy session'
                                required
                            />

                            <DateField {...f('date')} type='datetime-local' label='Date' required />

                            <TimeField {...f('time')} type='datetime-local' label='Time' />
                        </div>
                    )}
                </FormWrapper>
            </div>
        </div>
    )
}
